import { render, staticRenderFns } from "./BackendError.vue?vue&type=template&id=0c2d1158&scoped=true&"
import script from "./BackendError.vue?vue&type=script&lang=js&"
export * from "./BackendError.vue?vue&type=script&lang=js&"
import style0 from "./BackendError.vue?vue&type=style&index=0&id=0c2d1158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2d1158",
  null
  
)

export default component.exports